export enum STEPS_ENUM {
	EmailStep = 0,
	CodeStep = 1,
	ConnectStep = 3,
	StartStep = 5,
	SignUpCompleteStep = 6,
	LoginSelectStep = 7,
EmailStepConnect = 8
}
